webpackJsonp([73],{

/***/ "/vY6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TemplateLandingPages_1 = __webpack_require__("9/76");
var underscore_extensions_1 = __webpack_require__("R0iF");
var LandingTemplate = (function () {
    LandingTemplate.$inject = ["$state", "$element", "$rootScope", "$compile"];
    function LandingTemplate($state, $element, $rootScope, $compile) {
        var _this = this;
        this.$state = $state;
        this.$element = $element;
        this.$rootScope = $rootScope;
        this.$compile = $compile;
        this.scopeList = [];
        this.landingData = TemplateLandingPages_1.default.find(function (landing) { return _this.$state.is(landing.url); });
    }
    LandingTemplate.prototype.$onInit = function () {
        this.compileSections();
    };
    LandingTemplate.prototype.$onDestroy = function () {
        this.scopeList.forEach(function (scope) { return scope.$destroy(); });
    };
    LandingTemplate.prototype.compileSections = function () {
        var _this = this;
        var sectionsContainerEl = angular.element(this.$element[0].querySelector('#sections'));
        var getKey = function (key) {
            var curKey = key === 'title' ? 'ltTitle' : key;
            return underscore_extensions_1.Utils.toHyphenCase(curKey);
        };
        var sectionDataToString = _.compose((function (attrsArr) { return attrsArr.join(' '); }), (function (keys) { return keys.map(function (key) { return getKey(key) + "=\"" + key + "\""; }); }), _.keys);
        this.landingData.sections.forEach(function (section) {
            var attrs = sectionDataToString(section);
            var sectionEl = angular.element("<section-" + section.name + " " + attrs + "></section-" + section.name + ">");
            var scope = Object.assign(_this.$rootScope.$new(), section);
            _this.scopeList.push(scope);
            sectionsContainerEl.append(_this.$compile(sectionEl)(scope));
        });
    };
    return LandingTemplate;
}());
angular.module('animatronApp.landingTemplate', []).component('landingTemplate', {
    controller: LandingTemplate,
    templateUrl: __webpack_require__("SjG1")
});


/***/ }),

/***/ "SjG1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/landing-template_404541639e794e34598793e5499171f6.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/73-257c10c0995a4d25fa59.min.js